var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    key: _vm.quizProgress,
    staticClass: "d-flex flex-column",
    class: "app-".concat(_vm.quizProgress).concat(_vm.matchup ? ' d-flex flex-column' : '')
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in",
      "appear": ""
    }
  }, [_vm.$slots.default ? _c('div', [_vm._t("default")], 2) : _vm._e()]), _vm.matchup ? _c('ProgressBarContainer', {
    staticClass: "mx-2 mx-md-0",
    scopedSlots: _vm._u([{
      key: "bar",
      fn: function fn() {
        return [_vm.quizProgress ? _c('b-progress', {
          staticClass: "rounded",
          attrs: {
            "value": _vm.quizProgress,
            "max": _vm.barMax,
            "height": "0.5rem",
            "variant": "primary"
          }
        }) : _vm._e()];
      },
      proxy: true
    }], null, false, 1636439842)
  }) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }